import React from "react";

import styled from "styled-components";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  /** Logo to display */
  logo?: string;
  /** Link to follow when logo clicked */
  href?: string;
  /** Width to set on the logo */
  width?: string;
  /** Height to set on the logo */
  height?: string;
  /** Custom margin to set on the logo*/
  margin?: string;
}

const Logo = ({ logo, href, ...props }: Props) => {
  return (
    <a href={href} {...props}>
      {logo && <img src={logo} alt={logo} />}
    </a>
  );
};

export default styled(Logo)<Props>`
  display: flex;
  align-items: center;
  margin: ${(props) => (props.margin ? props.margin : "0 0.5rem")};
  img {
    width: ${(props) => props.width && `width:` + props.width};
    height: ${(props) => props.height && `height:` + props.height};
  }
`;
